import { ModelBase } from "@singularsystems/neo-core";

export default class ContactUsDetails extends ModelBase {

    constructor() {
        super();
        this.makeObservable();
    }
    
    public departmentName: string = "";

    public contactNo: string = "";

    public address: string = "";

    // Client only properties / methods
}